import { useEffect } from "react";
import { Button, ButtonSize, TextField } from "@bale/ui";
import CardWrapper from "components/commons/cardWrapper/CardWrapper";
import Footer from "components/commons/footer/Footer";
import {
  NavigationActions,
  OrganizationAuthSteps,
} from "core/navigation/navigation.slice";
import {
  GeneralErrors,
  GeneralValidators,
  useInputHandler,
} from "hooks/useInputHandler";
import { strings } from "intl/fa";
import { useAppDispatch, useAppSelector } from "utils/store";
import styles from "../Invoicing.module.scss";
import classNames from "classnames";
import {
  OrganizationAuthStepsArr,
  inputLengths,
} from "../OrganizationInvoicing";
import { AuthActions } from "core/auth/auth.slice";
import { ProgressSteps } from "components/commons/progressSteps/ProgressSteps";
import { rejectionReasonsErrors } from "utils/auth";

export function RegistrationInformationStep() {
  const dispatch = useAppDispatch();
  const myPanel = useAppSelector((state) => state.auth.myPanel);
  const nationalIdHandler = useInputHandler({
    initialValue: myPanel.shenase_melli,
    numberOnly: true,
    rules: [
      GeneralValidators.required,
      GeneralValidators.minLength(inputLengths.nationalId),
    ],
    errorMessages: {
      [GeneralErrors.Required]: strings.common.error.required,
      [GeneralErrors.MinimumLength]:
        strings.invoicing.errors.national_id_length,
    },
  });

  const commercialNumberHandler = useInputHandler({
    initialValue: myPanel.economic_number,
    numberOnly: true,
    rules: [
      GeneralValidators.required,
      GeneralValidators.minLength(inputLengths.commercialNumber),
    ],
    errorMessages: {
      [GeneralErrors.Required]: strings.common.error.required,
      [GeneralErrors.MinimumLength]:
        strings.invoicing.errors.commercial_number_length,
    },
  });

  const inputsAreValid = Boolean(
    nationalIdHandler.rawValue &&
      commercialNumberHandler.rawValue &&
      !nationalIdHandler.error &&
      !commercialNumberHandler.error
  );

  const submitClickHandler = () => {
    dispatch(
      AuthActions.setAuthenticationDraft({
        shenase_melli: nationalIdHandler.rawValue,
        economic_number: commercialNumberHandler.rawValue,
      })
    );
    dispatch(
      NavigationActions.setOrganizationAuthSteps(
        OrganizationAuthSteps.Documents
      )
    );
  };

  useEffect(() => {
    const rejectionErrorIds = myPanel.reason.split(",");

    if (rejectionErrorIds.includes("100")) {
      commercialNumberHandler.setError(rejectionReasonsErrors["100"]);
    }

    if (rejectionErrorIds.includes("101")) {
      nationalIdHandler.setError(rejectionReasonsErrors["101"]);
    }
  }, [myPanel.reason]);

  return (
    <>
      <CardWrapper className={styles.Card}>
        <div className={styles.Form}>
          <div className={classNames(styles.HelpsWrapper, styles.FormItem)}>
            <div className={styles.HelpMain}>{strings.invoicing.help_main}</div>
            <div className={styles.HelpDesc}>
              {strings.invoicing.help_organization}
            </div>
          </div>
        </div>
        <ProgressSteps
          currentStep={OrganizationAuthSteps.RegistrationInformation}
          steps={OrganizationAuthStepsArr}
          showOnmobile
        />
        <TextField
          {...nationalIdHandler}
          label={strings.invoicing.national_id}
          placeholder="XXXXXXXXXXX"
          dir="ltr"
          maxLength={inputLengths.nationalId}
        />
        <TextField
          {...commercialNumberHandler}
          label={strings.invoicing.commercial_number}
          placeholder="XXXXXXXXXXX"
          dir="ltr"
          maxLength={inputLengths.commercialNumber}
        />
      </CardWrapper>
      <Footer>
        <Button
          onClick={submitClickHandler}
          text={strings.common.button.submit_and_continue}
          size={ButtonSize.XLarge}
          disable={!inputsAreValid}
        />
      </Footer>
    </>
  );
}
